import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { TicketService } from '../../../../services/ticket.service';
import { AdminTicketService } from '../../../../services/adminticket.service';
import { GeneralService } from '../../../../services/general.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';
import { formatDate } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-admin-support-ticket-list',
  templateUrl: './admin-support-ticket-list.component.html',
  styleUrls: ['./admin-support-ticket-list.component.css']
})
export class AdminSupportTicketListComponent implements OnDestroy, OnInit {

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions: any;
  @Input()  filter1: string;
  @Input()  filter2: string;
  @Input()  filter3: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  datatableTrigger: Subject<any> = new Subject();

  lang: any;
  tickets: any;
  categories: any;
  timezone = localStorage.getItem('timezone');
  

  constructor(
    private adminticketService: AdminTicketService,
    private generalService: GeneralService,
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.datatableConfig();
    this.datatableFilter();
    this.getData();
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  datatableConfig(): void {
    this.datatableOptions = {
      paging: false,
      bAutoWidth: false,
      columnDefs: [ 
        {
            "targets": [ 6 ],
            "visible": false,
        },
        {
            "targets": [ 7 ],
            "visible": false,
        },
        {
          "targets": [ 8 ],
          "visible": false,
        }
      ]
    };

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';

  }

  datatableFilter(): void{

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = this.trimSpaces(data[5]) || '';
      const filt2 = data[6] || '';
      const filt3 = data[7] || '';
   
      var status = true;

      if (this.filter1 && filt1 != this.filter1)
        status = false;
      if (this.filter2 && filt2 != this.filter2)
        status = false;
      if (this.filter3 && filt3 != this.filter3)
        status = false;

      return status;
    });

  }

  datatableFilterAction(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  getData() {
    let userType = localStorage.getItem('super_user');
    this.adminticketService.getList(userType)
      .subscribe(
        (res) => {

          this.categories = res.data.categories;
          this.tickets = res.data.tickets;
          this.lang = this.adminticketService.listLang(res);

          setTimeout(() => {
            this.datatableTrigger.next();
          }, 5);
        }
      );


  }

  closeTicket(ticket_id): void{
    
    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to close this ticket?')
        .subscribe(
          (confirmed) => {
            
            if (!confirmed)
              return;

            this.adminticketService.closeTicket(ticket_id)
            .subscribe(

              (res) => {

                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);
                  
                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.TICKET_LIST]);
                    });
                }
                else
                  this.generalService.notify_msg('error', res.msg);
              }


            );
              
          });

  }

  trimSpaces(value){
    if (value === undefined)
      return 'undefined';
    return value.replace(/\s/g, "");    
  }

}
